import { Logo } from './Logo';
import './app-loading.css';

/** The full-page loader: while the app's chunk downloads, and while the session's business is still unknown. */
export const AppLoading = () => (
  <div className="app-loading" role="status" aria-busy="true" aria-label="Loading">
    <span className="app-loading__mark">
      <Logo size={40} />
    </span>
  </div>
);
